module.exports = __webpack_public_path__ + "img/bg@2x-bg.ed95d9a0.png";